import { HIDE_MESSAGE } from '.';

export const clearSuccess = (type) => ({ type: HIDE_MESSAGE, payload: type });
